import http from './fetch'
import { BASE } from './base'
const WECHAT = 'WECHAT-API/'
// 珂蓝官网资讯列表
export function apiListInfoByPage(params) {
  return http(BASE + WECHAT + 'kelan/listInfoByPage', params, 'get', true, true)
}
